import { FunctionComponent } from 'react'

import { GameWithUserInformation } from 'containers/GamesBlock/types'

import { FreeRound } from './FreeRound'
import { Unfinished } from './Unfinished'

type FilterFn = (game: GameWithUserInformation) => boolean

const allGameStates: [FilterFn, FunctionComponent][] = [
  [({ hasFreeRounds }) => hasFreeRounds, FreeRound],
  [({ isUnfinished }) => isUnfinished, Unfinished],
]

export function useGameState(game: GameWithUserInformation) {
  return allGameStates.filter(([filterFn]) => filterFn(game)).map(([, State]) => State)
}
